import { requests } from '@/libs/axios/axios'
// import { AxiosResponse } from 'axios'
import { ChatEndpoints } from '../chat-endpoints'

export const regenerateMessage = async (data: { message_id: string; path_id: string; chat_id: string }) => {
  return requests.post(ChatEndpoints.REGENERATE_MESSAGE, data, {
    timeout: 30000
  })
}
